<template>
    <div class="my-dashboard">
        <el-menu
            class="dashboard-menu"
            text-color="#fff"
            active-text-color="#fff"
            :router="true"
            :default-active="activeIdx.toString()"
            v-if="userInfo"
        >
            <el-tooltip v-for="(item, index) in menuItems" :key="index" class="item" effect="dark" :content="item.tooltip" placement="right" :disabled="item.disabled">
                    <el-menu-item :index="index.toString()" @click="item.click(item.route)">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.title}}</span>
                    </el-menu-item>
            </el-tooltip>
        </el-menu>
        <div class="my-dashboard-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "MyDashboard",
    components: {
        // HelloWorld
    },
    computed: {
        ...mapState({
            accessToken: state => state.accessToken,
            userInfo: state => state.userInfo
        }),
        hasIdentificationStarted() {
            if (this.userInfo && this.userInfo.identification_type) {
                return true;
            }
            return false;
        },
        identification_type() {
            if (this.userInfo) {
                return this.userInfo.identification_type;
            }
            return null;
        },
        activeIdx() {
            let ctrl = this;
            return ctrl.menuItems.findIndex(menu => {
                return ctrl.$route.path.indexOf(menu.route) >= 0;
            });
        },
    },
    data() {
        return {
            menuItems: [
                {title: "My Balance", icon: "el-icon-menu", route: "/dashboard", disabled:true, click: this.onMenuClick.bind(this)},
                {title: "My Identification", icon: "el-icon-user", route: "/dashboard/identification", disabled:this.hasIdentificationStarted, tooltip:"Click and start verify your identification", click: this.onMenuClick.bind(this)},
                {title: "Account Security", icon: "el-icon-lock", route: "/dashboard/security", disabled:true, click: this.onMenuClick.bind(this)},
                {title: "Deposits", icon: "el-icon-money", route: "/dashboard/deposit", disabled:true, click: this.onMenuClick.bind(this)},
                {title: "Withdrawals", icon: "el-icon-bank-card",route: "/dashboard/withdraw", disabled:true, click: this.onMenuClick.bind(this)},
                {title: "Payment", icon: "el-icon-present", route: "/dashboard/payment", disabled:true, click: this.onMenuClick.bind(this)},
                {title: "My Bank Account", icon: "el-icon-wallet",route: "/dashboard/bank-account", disabled:true, click: this.onMenuClick.bind(this)},
                {title: "My Address Book", icon: "el-icon-notebook-1",route: "/dashboard/address", disabled:true, click: this.onMenuClick.bind(this)},
                {title: "My Exchanges", icon: "el-icon-document-copy",route: "/dashboard/exchange", disabled:true, click: this.onMenuClick.bind(this)},
                // {title: "My Invoice", icon: "el-icon-coin",route: "/dashboard/invoice", disabled:true, click: this.onMenuClick.bind(this)},
            ]
        };
    },
    methods: {
        ...mapActions(["setAccessToken"]),
        onLogoutClick() {
            this.setAccessToken();
            this.$router.push({ path: "/" });
        },
        onMenuClick(path) {
            this.$router.push({ path });
        }
    }
};
</script>

<style scoped>
.el-menu-item.is-active {
    background-color: #016395;
}
.el-menu {
    height: 100%;
    background-color: #0070a9;
    border-right: solid 1px rgba(255, 255, 255, 0.15);
    width: 200px;
}
.el-menu-item:focus,
.el-menu-item:hover {
    outline: 0;
    background-color: rgba(0, 0, 0, 0.3);
}
.my-dashboard {
    width: 100%;
    height: 100%;
    display: flex;
}
.my-dashboard-content {
    flex: 1;
    overflow: auto;
}
.identification-badge-dot {
    width: 100%;
}
</style>
<style>
.identification-badge-dot .is-dot {
    left: 150px;
    top: 16px;
}
</style>
